/**
 * External dependencies
 */
var tzdetect = require( 'jstimezonedetect' );

/**
 * Detect and return the current timezone of the browser
 *
 * @return {String} timezone
 */
module.exports = function timezone() {
	var detected = tzdetect.jstz.determine();
	return detected ? detected.name() : null;
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/vl-i18n-calypso/lib/mixin/timezone.js
// module id = 217
// module chunks = 0